//
//
//
//
//
//
//

import _ from 'underscore'
// import DIC from '@/index/dictonary'

export default {
  props: {
    tab: {
      default: ''
    }
  },
  data: () => ({
    search: {
      beginTime: undefined,
      endTime: undefined,
      q: undefined,
      status: undefined
    },
    table: [],
    loading: false,
    page: {
      pageNo: 1,
      pageSize: 10,
      total: 0
    },
  }),
  components: {
    PageHeader: () => import('./components/PageHeader/index.vue'),
    PageMain: () => import('./components/PageMain/index.vue')
  },
  watch: {
    tab: {
      handler (val) {
        if (val && val == 'pick') {
          this.handleLoadTableData()
        }
      },
      immediate: true
    }
  },
  mounted () {
  },
  methods: {
    handleLoadTableData () {
      this.loading = true
      let data = _.extend({}, this.search)
      // console.log('data', data)
      data.pageNo = this.page.pageNo
      data.pageSize = this.page.pageSize
      this.$axios.get('/mtea/store/admin/purchase/pick/list', { params: data }).then(res => {
        // console.log('res', res)
        this.table = res.records
        this.page.total = res.total
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
